import React, { Component } from "react";
import { NormalButton } from "component/common";
import "./style.scss";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getCommonApi, commonCreateApi } from "redux/actions/common";
import { transactionSettingListAct } from "redux/actions/transactionHistory";

export class DownloadInsuranceClass extends Component {
  state = {
    downloadUrl: "",
    downloadText: "",
  };

  componentDidMount() {
    console.log(this.props.location.state, "state");
    this.props
      .getCommonApi(`insurancepdf/?sa_transacno=${this.props.location.state}`)
      .then((response) => {
        this.setState({
          downloadUrl: response.data[0],
          downloadText: response.data[1],
        });
      });
  }
  handleDownload = () => {
    fetch(this.state.downloadUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `${this.state.downloadText}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.props.history.push("admin/transactionhistory");
      })
      .catch((error) => {
        console.error("Error downloading the PDF:", error);
      });
  };

  handleOpen = () => {
    window.open(this.state.downloadUrl, "_blank");
  };
  render() {
    return (
      <div className="billing-section p-3">
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0 my-3 d-flex">
          <p className="label-head container">Insurance Claim Document</p>
        </div>
        <div className="container">
          <p>
            Insurance Claim Document has been created. Please remember to
            download the PDF document below. System will not retain a copy of
            the PDF file if the browser window is closed
          </p>
          <div className="d-flex justify-content-between mt-3">
            <p className="downloadUrl" onClick={this.handleOpen}>
              {this.state.downloadText}
            </p>
            <NormalButton
              label={"Download"}
              className="print colorTheme4"
              onClick={this.handleDownload}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  appointmentDetail: state.appointment.appointmentDetail,
  tokenDetails: state.authStore.tokenDetails,
  transactionSettingList: state.transactionStore.transactionSettingList,
  transactionOrderChangeList: state.transactionStore.transactionOrderChangeList,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getCommonApi,
      commonCreateApi,
      transactionSettingListAct,
    },
    dispatch
  );
};

export const DownloadInsurance = connect(
  mapStateToProps,
  mapDispatchToProps
)(DownloadInsuranceClass);
